import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'

import Link from 'components/atoms/link'

import { CSP_SALES_FLOW } from 'config/routes'

const StyledLink = styled(Link)`
  display: inline-block;
  font-weight: 400;
  line-height: ${({ theme }) => theme.baseFontSize};
`

const CarfileCSPPrices = ({ className, carfile, showCspCalculationLink }) => {
  const { t } = useTranslation()
  const {
    dealernr: dealerId,
    kenteken: licensePlate,
    km_binnen: mileage,
  } = carfile

  if (!showCspCalculationLink) {
    return null
  }

  return (
    <StyledLink
      className={className}
      to={`${CSP_SALES_FLOW}/0?carFileId=${carfile.id}&dealerId=${dealerId}&licensePlate=${licensePlate}&currentMileage=${mileage}`}
      data-test-e2e="link-calculate-costs"
    >
      {t('calculateMaintenanceCosts')}
    </StyledLink>
  )
}

CarfileCSPPrices.propTypes = {
  carfile: PropTypes.object.isRequired,
  className: PropTypes.string,
  showCspCalculationLink: PropTypes.bool,
}

CarfileCSPPrices.defaultProps = {
  className: null,
  showCspCalculationLink: true,
}

export default CarfileCSPPrices
